import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { InputBoxesField } from 'components/forms/InputBoxes';
import { options as equipmentOptions } from 'helpers/fieldOptions/car/equipments';
import cn from './styles.local.less';

export default class EquipmentsItem extends PureComponent {
  static propTypes = {
    onChanged: PropTypes.func.isRequired,
  };

  render() {
    const { onChanged } = this.props;

    return (
      <Fragment>
        {equipmentOptions.map(({ fieldName, ...option }, index) => (
          <InputBoxesField
            boxClassName={cn.inputBox}
            className={cn.inputBoxField}
            key={`${fieldName}-${index}`}
            name={fieldName}
            options={[option]}
            type="checkbox"
            onChanged={onChanged}
            xs={12}
          />
        ))}
      </Fragment>
    );
  }
}
